/* ====================================================
                Window functions
====================================================*/
window.onscroll = function() {
    stikyMenu();
};

/* ====================================================
                Global variables
====================================================*/
const body = document.querySelector('body');

/*  Other global variables
WWW_URL = "https://metsaoksjon.1kdigital.com";
WWW_HOST = "metsaoksjon.1kdigital.com";
WWW_INDEX = "https://metsaoksjon.1kdigital.com/index.php";
ID_CARD_AUTH_URL = "https://esteid-card-auth.metsaoksjon.1kdigital.com/";
SMART_ID_AUTH_URL = "https://smart-id.metsaoksjon.1kdigital.com/";
MODULE_NAME = "avaleht"
USER_ID = 0 logged out or >0 logged in
KM_SIZE = 20;
*/

/* ====================================================
                    Sticky menu
====================================================*/
function stikyMenu() {
    const header = document.querySelector(".top-navbar");
    const offsetTop = document.querySelector(".main-wrapper").offsetTop;
    const mainWrapper = document.querySelector(".main-wrapper");
    const pageYOffset = window.pageYOffset;
    const height = document.body.clientHeight;
    let isSticky = pageYOffset > offsetTop;
    let notSticky = pageYOffset <= offsetTop;
    let maxHeighth = ((height- (offsetTop + header.offsetHeight))) > (offsetTop + header.offsetHeight)
    if(maxHeighth) {
        if (notSticky) {
            if (header.classList.contains("sticky-menu")) {
                header.classList.remove("sticky-menu");
                mainWrapper.classList.remove("sticky-menu");

            }
        } else if (isSticky) {
            if (!header.classList.contains("sticky-menu")) {
                header.classList.add("sticky-menu");
                mainWrapper.classList.add("sticky-menu")

            }
        }
    }
}


/* ====================================================
    Home page logo active and deactivate
    (The other part is in /kaart/maaportaal.js)
====================================================*/
let logCards = document.querySelectorAll('.logo-card')
if(logCards) {
    logCards.forEach((logCard)=> logCard.addEventListener('click', handleActiveLogo));
}

function handleActiveLogo(){
    const map = document.getElementById("maaportaal-map");
    if(this.classList.contains('active')){
        handleActiveOne(this, logCards);
        map.innerHTML = '';
        Maaportaal.initMap("maaportaal-map", {module: MODULE_NAME, panel: false, height: '100%', url: KAART_URL}); //Initializes the original map
    } else{
        handleActiveOne(this, logCards);
        Maaportaal.ostuala(this.id, {module: MODULE_NAME, panel: false, height: '100%', url: KAART_URL}); //Initializes the clients post map
    }
}


/* ====================================================
            Mobile Menu
====================================================*/
let mobileMenuTriggers = document.querySelectorAll('.mobile-menu-btn')
let mobileAccordions = document.querySelectorAll('.mobile-accordion')
if(mobileMenuTriggers) {
    mobileMenuTriggers.forEach((mobileMenuTrigger)=> mobileMenuTrigger.addEventListener('click', handleActiveMobileMenu));
}
if(mobileAccordions) {
    mobileAccordions.forEach((mobileAccordion)=> mobileAccordion.addEventListener('click', handleActiveMobileAccordion));
}


function handleActiveMobileMenu(){
    handleMobileLoginPopup();
    handleActiveOne(this, mobileMenuTriggers);
}
function handleActiveMobileAccordion(){
    handleActiveParent(this, mobileAccordions);
}

function handleMobileLoginPopup(){
    mobileMenuTriggers.forEach((mobileMenuTrigger)=> {
        if(mobileMenuTrigger.firstElementChild.classList.contains('fa-times')){
            mobileMenuTrigger.firstElementChild.classList.remove('fa-times');
            mobileMenuTrigger.firstElementChild.classList.add('fa-bars');

        } else{
            mobileMenuTrigger.firstElementChild.classList.add('fa-times');
            mobileMenuTrigger.firstElementChild.classList.remove('fa-bars');

        }
    });
    if(body.classList.contains('mobile-active')){
        body.classList.remove('mobile-active');
        body.classList.remove('mobile-active');
    } else{
        body.classList.add('mobile-active');

    }

}

/* ====================================================
            Mobile friendly tables
====================================================*/
const docWidth = document.documentElement.offsetWidth;
if(docWidth < 600) {
    document.querySelectorAll('table').forEach((el)=> {
           /* if (el.offsetWidth > docWidth) {
               
            }*/
        el.parentNode.classList.add("turn-mobile");
        body.classList.add('overflow-x');

        }
    );
}

/* ====================================================
            Re-usable functions
====================================================*/
function handleActiveOne(self, elementsAll){
    if(self.classList.contains('active')){
        elementsAll.forEach((element)=>{
            element.classList.remove('active');
        });
    } else{
        elementsAll.forEach((element)=>{
            element.classList.remove('active');
        });
        self.classList.add('active');
    }
}

function handleActiveParent(self, elementsAll){
    if(self.parentElement.classList.contains('active')){
        elementsAll.forEach((element)=>{
            element.parentElement.classList.remove('active');
        });
    } else{
        elementsAll.forEach((element)=>{
            element.parentElement.classList.remove('active');
        });
        self.parentElement.classList.add('active');
    }
}

window.addEventListener('load', () => {
    switchTabs();
    let activeTab = localStorage.getItem('active-tab');
    let li
    if (document.querySelector('a[data-tabs-target=' + activeTab + ']') !== null) {
        li = document.querySelector('a[data-tabs-target=' + activeTab + ']').parentElement;
    }
    console.log('activeTab:', li)
    if (activeTab && li !== undefined) {
        li.click();
    }
});

const tabsTitle = document.querySelectorAll('.tabs-title');
const tabsContent = document.querySelectorAll('.tabs-content');

const switchTabs = () => {
    tabsTitle.forEach((tab) => {
        tab.addEventListener('click', (event) => {
            event.preventDefault();
            removeActiveTabTitleClass();
            tab.classList.add('is-active');
            tab.setAttribute('aria-selected', 'true');
            tab.firstChild.setAttribute('aria-selected', 'true');

            let target = tab.firstChild.getAttribute('data-tabs-target');
            // console.log('target', target)
            let targetTabContent = document.querySelector(`#${target}`);
            removeActiveTabContentClass();
            targetTabContent.classList.add('is-active');

            let checkbox = targetTabContent.querySelector('.tab-agreement__checkbox > label > input');
            let input = targetTabContent.querySelector('.offer-sum-wrapper > input');

            if (checkbox !== null) {
                checkbox.setAttribute('required', 'required');
                // console.log('checkbox', checkbox)
            }

            if (input !== null) {
                input.setAttribute('required', 'required');
                // console.log('input', input)
            }

            let offerType = document.querySelector('.offer-type');

            if (target === 'panel11') {
                offerType.setAttribute('value', 'automatic');
            }
            if (target === 'panel22') {
                offerType.setAttribute('value', 'below-starting-price');
            }

            let offerType2 = document.querySelector('.offer-type-2');

            if (target === 'panel1') {
                offerType2.setAttribute('value', 'standard-offer');
            }
            if (target === 'panel3') {
                offerType2.setAttribute('value', 'automatic-offer');
            }
            if (target === 'panel2') {
                offerType2.setAttribute('value', 'below-starting-price');
            }

            localStorage.setItem('active-tab', target);

            return false;
        })
    })
}

function removeActiveTabTitleClass() {
    tabsTitle.forEach((tab) => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
        tab.firstChild.setAttribute('aria-selected', 'false');
    })
}

function removeActiveTabContentClass() {
    document.querySelectorAll('.tabs-content > .tabs-panel').forEach((content) => {
        content.classList.remove('is-active');
    })
    let checkboxes = document.querySelectorAll('.tab-agreement__checkbox > label > input');
    checkboxes.forEach((checkbox) => {
        checkbox.removeAttribute('required');
    })
    let inputs = document.querySelectorAll('.offer-sum-wrapper > input');
    inputs.forEach((input) => {
        input.removeAttribute('required');
    })
}

function modifyOffer(event, isInc) {
    let target = event.target,
    parent = target.parentElement,
    input = parent.querySelector("input"),
    value = Number(input.value),
    step = Number(input.dataset.step),
    // initial = input.dataset.initialSum || step
    minimum = input.getAttribute('data-minimum-sum') || step
    initial = input.getAttribute('data-initial-sum') || step
    console.log('initial', input.dataset.initialSum )

    // input.value = (value !== 0 ? (isInc ? value + step : (value > step ? value - step : step)) : initial);
    input.value = (value !== 0 ? (isInc ? (value < minimum ? minimum : value + step) : (value > minimum ? value - step : minimum)) : initial);
}
let list = document.querySelectorAll(".offer-increment");
    list.forEach(elm => {
        elm.addEventListener('click', function (event) {
        event.preventDefault();
        modifyOffer(event, true)
        return false;
    });
});
list = document.querySelectorAll(".offer-decrement");
list.forEach(elm => {
        elm.addEventListener('click', function (event) {
        event.preventDefault();
        modifyOffer(event, false);
        return false;
    });
});

let makeOffer = document.querySelectorAll('.make-offer');

makeOffer.forEach((offer) => {
    offer.addEventListener('click', (event) => {
        event.preventDefault();

        document.querySelectorAll(".error").forEach((item) => {item.classList.remove('error')})
        
        let panel1Checkbox = document.querySelector('#panel1 > .tab > .tab-agreement > .tab-agreement__checkbox > label > input');
        let panel2Checkbox = document.querySelector('#panel2 > .tab > .tab-agreement > .tab-agreement__checkbox > label > input');
        let panel2Input = document.querySelector('#panel2 > .tab > .tab-agreement > div > .offer-sum-wrapper > input');
        let panel3Checkbox = document.querySelector('#panel3 > .tab > .tab-agreement > .tab-agreement__checkbox > label > input');
        let panel3Input = document.querySelector('#panel3 > .tab > .tab-agreement > div > .offer-sum-wrapper > input');

        if (offer.classList.contains('make-offer-1')) {

            if (panel1Checkbox.checked === true) {
                mainForm['paku'].value = 1; mainForm.submit();
            } else {
                panel1Checkbox.parentElement.classList.add('error');
            }
        }
        if (offer.classList.contains('make-offer-2')) {
        
            if (panel2Checkbox.checked !== true) {
                panel2Checkbox.parentElement.classList.add('error');
            } else if (panel2Input.value === '') {
                panel2Input.classList.add('error');
            } else {
                mainForm['paku_alla'].value = 1; mainForm.submit();
            }
        }
        if (offer.classList.contains('make-offer-3')) {

            if (panel3Checkbox.checked !== true) {
                panel3Checkbox.parentElement.classList.add('error');
            } else if (panel3Input.value === '' || panel3Input.value < Number(panel3Input.getAttribute('data-minimum-sum'))) {
                panel3Input.classList.add('error');
            } else {
                mainForm['salvesta'].value = 1; mainForm.submit();
            }
        }
        return false;
    })
})

let sendApplication = document.querySelector('.send-application');

if (sendApplication !== null) {
    sendApplication.addEventListener('click', (event) => {
        event.preventDefault();

        document.querySelectorAll(".error").forEach((item) => {item.classList.remove('error')})

        let panel1Checkbox = document.querySelector('#panel11 > .tab > .tab-agreement > .tab-agreement__checkbox > label > input');
        let panel1Input = document.querySelector('#panel11 > .tab > .tab-agreement > div > .offer-sum-wrapper > input');
        let panel2Checkbox = document.querySelector('#panel22 > .tab > .tab-agreement > .tab-agreement__checkbox > label > input');
        let panel2Input = document.querySelector('#panel22 > .tab > .tab-agreement > div > .offer-sum-wrapper > input');

        let offerType = document.querySelector('.offer-type');

        if (offerType.getAttribute('value') === 'automatic') {
            if (panel1Checkbox.checked !== true) {
                panel1Checkbox.parentElement.classList.add('error');
            } else if (panel1Input.value === '' || panel1Input.value < Number(panel1Input.getAttribute('data-initial-sum'))) {
                panel1Input.classList.add('error');
            } else {
               mainForm.submit();
            }
        }

        if (offerType.getAttribute('value') === 'below-starting-price') {
            if (panel2Checkbox.checked !== true) {
                panel2Checkbox.parentElement.classList.add('error');
            } else if (panel2Input.value === '' || panel2Input.value < Number(panel2Input.getAttribute('data-step'))) {
                panel2Input.classList.add('error');
            } else {
                mainForm.submit();
            }
        }

        return false;
    })
}